import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("34bba1af35", "._3c9c40fea579f008__root{min-inline-size:0;overflow:hidden}");
}
export default {"root":"_3c9c40fea579f008__root"};
